import styled from "styled-components";
import { List, ListItem, ListItemIcon } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  burguerIconContent: {
    padding: "16px 16px 0px 16px",
  },
  menuNav: {
    paddingRight: 10,
  },
  sideBarNav: {
    height: "85vh",
  },
  transitionMenu: {
    transition: "all 0.3s ease-in-out",
  },
}));

export const IconItemList = withStyles(() => ({
  root: {
    minWidth: "inherit",
  },
}))(ListItemIcon);

export const ItemList = withStyles(() => ({
  root: {
    margin: "10px 0",
    "&.collapsedItem": {
      marginTop: 0,
    },
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: "0 16px",
    "& a.collapsedItemLink": {
      paddingLeft: "20px",
    },
    "& a": {
      padding: "8px 0",
    },
    "& a, span": {
      color: "#0033C6",
    },
    "&:hover": {
      backgroundColor: "#0033C6",
    },
    "&:hover span": {
      color: "#fff",
    },
  },
  selected: {
    backgroundColor: "#0033C6 !important",
    "& span": {
      color: "#fff",
    },
  },
}))(ListItem);

export const ListCollapsed = withStyles(() => ({
  padding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}))(List);

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  background: #e0e0e0;
`;

export const SideBar = styled.div`
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  border-radius: 0px 10px 10px 0px;
`;

export const SideBarItem = styled.div`
  a {
    /* width: 160px; */
    border: 1px;
    margin: 4px 0;
    border-radius: 0px 10px 10px 0px;
    text-decoration: none;
    color: #ffffff;
    padding: 10px;
    &:visited {
      color: #ffffff;
    }
    &:hover {
      color: ${(props) => props.theme.colors.blue.darkest};
      background: #ffffff;
      opacity: 0.8;
      & svg,
      path {
        color: #0033c6;
        fill: #0033c6;
      }
    }
    &.active {
      color: ${(props) => props.theme.colors.blue.darkest};
      background: #ffffff;
      opacity: 0.8;
      & svg,
      path {
        color: #0033c6;
        fill: #0033c6;
      }
    }
    & svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  width: 100%;
  position: relative;
  height: 100vh;
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const HeaderItemProfile = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    display: flex;
    justify-content: flex-end;
    :last-child {
      margin-top: 16px;
    }
  }
`;

export const HeaderItemTitle = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
`;
